/* Identity Pages WP Script (2018, Steve Graboski)
 * */

// helper functions
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// modal
var theModal = document.getElementById('modal');

// check whether the polyfill for the modal is registered
var polyreg = false;

// data
var filepath = "";
var filetype = "";
var filetitle = "";

if (window.HTMLDialogElement === undefined) {
    window.scriptLoader(scriptBasePath + 'dialog-polyfill.js', () => {
        // only activate the modals if they're on the page
        dialogPolyfill.registerDialog(theModal);
    });
}

// click event
document.querySelector('.content').addEventListener('click', function (e) {
    // download links
    if (e.target.tagName == 'A' && e.target.className.match('logo-link')) {
        e.preventDefault();
        var muPerssonnel = getCookie('ismupersonnel');
        logopath = e.target.dataset.logo;
        employeepath = e.target.getAttribute('href');
        filetitle = e.target.getAttribute('data-title');
        filetype = e.target.textContent;
        // if mu personnel, go to image
        if (muPerssonnel == "true") {
            window.open(employeepath, '_blank');
        }
        // if not mu personnel, go to
        else if (muPerssonnel == "false") {
            e.preventDefault();
            window.open("/brand/request/?filename=" + encodeURIComponent(logopath), "_blank");
        }
        // if mu personnel status yet logged, load the modal and make the yes/no links reflect the logo
        else if (muPerssonnel == "") {
            e.preventDefault();
            var noUrl = "/brand/request/?filename=" + encodeURIComponent(logopath);
            document.getElementById('modal-yes').setAttribute('href', employeepath);
            document.getElementById('modal-no').setAttribute('href', noUrl);
            if (!('showModal' in theModal)) {
                theModal.show();
            } else {
                theModal.showModal();
            }
        }
    } else {
        if (theModal.hasAttribute('open')) {
            theModal.close('canceled');
        }
    }
});

// click events for modal
document.querySelector('.modal').addEventListener('click', function (e) {
    if (e.target.tagName == "BUTTON") {
        if (e.target.className.match('modal-close')) {
            e.preventDefault();
            theModal.close('canceled');
        }
    } else if (e.target.tagName == "A") {
        var theDate = new Date();
        theDate.setHours(theDate.getHours() + 1);
        if (e.target.id == "modal-no") {
            document.cookie = "ismupersonnel=false; expires=" + theDate.toISOString();
        } else if (e.target.id == "modal-yes") {
            document.cookie = "ismupersonnel=true; expires=" + theDate.toISOString();
        }
        theModal.close('canceled');
    } else if (e.target.className == "modal-no") {
        document.cookie = "ismupersonnel=yes; expires=Thu, 18 Dec 2013 12:00:00 UTC";
        theModal.close('canceled');
    } else if (e.target.className == "modal") {
        theModal.close('canceled');
    }
})
